import React from "react";
import { SBBox } from "modules/Commons";
import { SBNewTable } from "modules/Commons/SBDataDisplays/SBTable/SBNewTable";
import { IConfigCSVErrors } from "domain/Config/Models/IConfigCSVErrors";
import { useStyles } from "../style";
import { useSupplyOrderUploadErrorsHeader } from "./useSupplyOrderUploadErrorsHeader";

interface SupplyOrderUploaderHelperErrorProps {
	errors: IConfigCSVErrors[];
}

const SupplyOrderUploaderHelperError: React.FC<
	SupplyOrderUploaderHelperErrorProps
> = ({ errors }) => {
	const classes = useStyles();
	const { headers } = useSupplyOrderUploadErrorsHeader();

	return (
		<SBBox className={classes.errorsTableContainer}>
			<SBNewTable
				key={errors.length}
				startRows={errors}
				defaultColumns={headers}
				onClick={() => {}}
				title="errors"
				disableToolbar
				virtualize
				containerHeight={295}
			/>
		</SBBox>
	);
};

export default SupplyOrderUploaderHelperError;
